import { FabricObject } from 'fabric';

import { DRAW_OBJECT_TYPE_RECT } from '../draw-canvas.constants';

export const isRectangle = (object: FabricObject) => {
  return object.type.toLowerCase() === DRAW_OBJECT_TYPE_RECT;
};
